import { render, staticRenderFns } from "./ShardView.vue?vue&type=template&id=6b535570&scoped=true&"
import script from "./ShardView.vue?vue&type=script&lang=ts&"
export * from "./ShardView.vue?vue&type=script&lang=ts&"
import style0 from "./ShardView.vue?vue&type=style&index=0&id=6b535570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b535570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
